module.exports = __webpack_public_path__ + "static/img/微信(2).955e8a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/xiaotubiao/微信(2).jpg
// module id = YV36
// module chunks = 41